import React, { useEffect, useRef } from 'react';
import { getPanel } from './Registry';
import styles from './index.less';

interface RightPanelProps {
  selectedNavItem: string | number;
  branch: any;
  onSuccess?: (data: any) => void;
}

const RightPanel: React.FC<RightPanelProps> = ({ selectedNavItem, branch, onSuccess }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    }
  }, [selectedNavItem, branch?.id]);

  return (
    <div ref={containerRef} className={styles.rightPanel}>
      {getPanel(selectedNavItem, branch, onSuccess)}
    </div>
  );
};

export default RightPanel;
